module.exports = function() {
  return new Worker(__webpack_public_path__ + "d40df91ab833bf6ce257.worker.js");
};